import React from 'react';
import './styles.css';
import { useNavigate } from 'react-router';
import InputMask from 'react-input-mask';
import { useForm } from 'react-hook-form';
import { LabelForm } from '../../components/LabelForm';
import { Button } from '../../components/Button';
import { Banner } from '../../components/Banner';
import { GetDadosLoja, ScrollToTop, SetDadosLoja, ValidarCPF } from '../../utils/utils';
import { GlobalContext } from '../../contexts/HomeContext';
import { Modal } from '../../components/Modal';
import { ConsultaClientePortaria, SetPreCadastroPortaria } from '../../utils/api/api';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import QRCode from 'react-qr-code';

export const PreCadastro = () => {
  const { dadosApp, setDadosApp } = React.useContext(GlobalContext);
  const [showModalSms, setShowModalSms] = React.useState(false);
  const [modalParams, setModalParams] = React.useState(false);
  const [modalLoading, setModalLoading] = React.useState(false);
  const [cliente, setCliente] = React.useState(null);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    setFocus,
    formState: { errors },
  } = useForm({ mode: 'onChange' });

  const handleAutenticar = async (code) => {
    if (code === '') {
      toast.error('Código Inválido');
      return;
    }

    setModalLoading(true);
    modalParams.codigo_sms = code;
    modalParams.cpf = code;
    modalParams.ocorrencia = 'validaSMS';
    const response = await SetPreCadastroPortaria(modalParams);

    setModalLoading(false);
    if (response.data.status == 0) {
      setShowModalSms(false);
      setModalParams((prevState) => {
        prevState.ativo = true;
        prevState.QRCode = response.data.msg;
        return { ...prevState };
      });
    } else {
      toast.error(response.data.msg);
    }
  };

  const handleValidForm = async (form) => {
    setModalLoading(true);

    const _telefone = removeMask(form.telefone);
    const arrayOfStrings = form.nomeCompleto.split(' ');
    const _nome = arrayOfStrings.length > 0 ? arrayOfStrings[0].trim() : '';
    const _sobrenome = form.nomeCompleto.replace(_nome, '').trim();
    const obj = {
      id: cliente ? cliente.id : 0,
      idloja: dadosApp.IdLoja,
      fantasia: dadosApp.Empresa.Empresa.fantasia.toUpperCase(),
      razao_social: dadosApp.Empresa.Empresa.razao.toUpperCase(),
      nome: _nome.toUpperCase(),
      sobrenome: _sobrenome.toUpperCase(),
      nome_completo: form.nomeCompleto.toUpperCase(),
      telefone_ddd: _telefone.substring(0, 2),
      ddd: _telefone.substring(0, 2),
      telefone: _telefone.substring(2),
      cpf: form.cpf,
      email: form.email,
      data_aniversario: form.data_aniversario,
      ocorrencia: 'cadastro',
      validado: dadosApp.Empresa.Config.portaria_sem_validacao,
    };

    setModalParams(obj);

    const response = await SetPreCadastroPortaria(obj);

    setModalLoading(false);

    if (response.data.status == 0) {
      if (dadosApp.Empresa.Config.portaria_sem_validacao === 1 || cliente?.id > 0) {
        navigate('/loja/PageSuccess?msg=Cadastro Realizado com Sucesso ', {
          replace: true,
        });
        return;
      }

      if (response.data.msg === 'sucesso') {
        setShowModalSms(true);
      } else {
        setShowModalSms(false);
        setModalParams((prevState) => {
          prevState.ativo = true;
          prevState.QRCode = response.data.msg;
          return { ...prevState };
        });
      }
    } else {
      if (response.data.msg === 'Código SMS inválido.' && !showModalSms) {
        setShowModalSms(true);
      } else {
        toast.error(response.data.msg);
      }
    }
  };

  const removeMask = (el) => {
    let element = el;
    for (let index = 0; index < el.length; index++) {
      element = element.replace('+55', '');
      element = element.replace('_', '');
      element = element.replace('/', '');
      element = element.replace(' ', '');
    }
    return element;
  };

  React.useEffect(() => {
    if (cliente?.id > 0) {
      setValue('nomeCompleto', cliente.nome_completo);
      setValue('telefone', cliente.ddd + '' + cliente.telefone);
      setValue('email', cliente.email);
      setValue('data_aniversario', cliente.data_aniversario);
    }
  }, [cliente, setValue]);

  React.useEffect(() => {
    ScrollToTop();
  }, []);

  // persiste os dados da loja
  React.useEffect(() => {
    if (dadosApp.IdLoja === 0) {
      const _dados = GetDadosLoja();
      if (_dados?.IdLoja > 0) setDadosApp(_dados);
      else navigate('/loja/Page404?message=' + 'Escaneie novamente o QRCode');
    } else {
      SetDadosLoja(dadosApp);
    }
  }, [dadosApp, setDadosApp, navigate]);

  return (
    <div style={{ backgroundColor: '#FFF' }}>
      <div
        style={{
          backgroundColor: '#FFF',
          position: 'sticky',
          top: 0,
          zIndex: 9999,
          borderBottom: '1px solid #ebebeb',
        }}
      >
        <h4 className="title-category" style={{ color: '#444', textAlign: 'center', padding: 13 }}>
          Pré-Cadastro
        </h4>
      </div>
      <div id="top"></div>
      <div id="categorias"></div>
      <Banner showStatusLoja={false} />
      <div
        className="container"
        style={{
          position: 'relative',
          textAlign: 'center',
          margin: 'auto',
          padding: '20px 30px',
        }}
      >
        {modalParams.ativo && (
          <>
            <p className="padBottom20" style={{ fontSize: 16, fontWeight: 500 }}>
              {`Parabéns ${modalParams.nome}, o seu pré-cadastro foi realizado com sucesso.`}
            </p>
            <p className="padBottom20" style={{ fontSize: 16, fontWeight: 500, marginBottom: 40 }}>
              {`Quando for solicitado basta informar o seu número de telefone ou o QRCode abaixo.`}
            </p>
            <div className="padBottom20" style={{ background: 'rgb(249 250 251)', margin: '-30px', paddingTop: 40 }}>
              <QRCode id="qr" value={modalParams.QRCode} size={100} />
            </div>
          </>
        )}
        {!modalParams.ativo && (
          <form
            onSubmit={handleSubmit(handleValidForm)}
            className="modal-content-dialog padTop20"
            style={{ borderTop: 0, padding: '15px 0px 0 0px' }}
          >
            <div className="form-container">
              <LabelForm text="CPF" />
              <input
                type="text"
                maxLength="14"
                placeholder=""
                className="form-control"
                disabled={modalLoading}
                {...register('cpf', {
                  validate: (value) => {
                    if (value !== '') {
                      if (isNaN(value) || !ValidarCPF(value)) return false;
                      else {
                        setModalLoading(true);
                        setTimeout(async () => {
                          const response = await ConsultaClientePortaria({ idloja: dadosApp.IdLoja, cpf: value });
                          if (response.data.status == 0) {
                            const _cliente = response.data?.gw_portaria_cadastro[0];
                            if (_cliente) {
                              setCliente(_cliente);
                              setFocus('nomeCompleto');
                              setValue('telefone', _cliente.ddd + _cliente.telefone);
                            } else setCliente(null);
                          }
                          setModalLoading(false);
                        }, 2500);
                      }
                    } else return false;
                  },
                })}
              />
              {errors.cpf && <p className="form-errors">CPF Inválido</p>}
            </div>

            <div className="form-container">
              <LabelForm text="Nome Completo" />
              <input
                type="text"
                placeholder=""
                className="form-control"
                {...register('nomeCompleto', {
                  validate: (value) => value !== '',
                })}
              />
              {errors.nomeCompleto && <p className="form-errors">Informe o seu nome completo</p>}
            </div>

            <div className="form-container">
              <LabelForm text="Celular com ddd " />
              <InputMask
                type="tel"
                placeholder=""
                className="form-control"
                mask={'+5\\5 99 99999 9999'}
                maskChar=" "
                alwaysShowMask={false}
                //onChange={onChange}
                {...register('telefone', {
                  validate: (value) => {
                    const _telefone = removeMask(value);
                    return _telefone.length === 11;
                  },
                })}
              />
              {errors.telefone && <p className="form-errors">Telefone Inválido</p>}
            </div>

            <div className="form-container">
              <LabelForm text="Email" />
              <input
                type="text"
                placeholder=""
                className="form-control"
                {...register('email', {
                  validate: (value) => {
                    if (value === '') return true;
                  },
                  //required: 'Obrigatório',
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Email inválido',
                  },
                })}
              />
              {errors.email && <p className="form-errors">Email Inválido</p>}
            </div>

            <div className={'form-container'}>
              <LabelForm text={'Data Aniversário'} labelFor={'nascimento'} />
              <input type="date" placeholder="" className={'form-control'} {...register('data_aniversario')} />
            </div>

            <div className="padTop20 padBottom20">
              {/* <Button type="submit" text="Salvar" textAlign="center" className="btn_1 full-width btnRounded" /> */}
              <Button type="submit" text="Enviar" className="btn_1 btnGradient width-full clearfix " />
            </div>
          </form>
        )}
      </div>

      {modalLoading && (
        <Modal
          title=""
          isFooter={false}
          visibility={modalLoading}
          param={{ msg: 'Aguarde...' }}
          page="LOADING"
          customPosition="loading-modal"
        />
      )}

      {showModalSms && (
        <Modal
          param={{
            display: showModalSms,
            cliente: modalParams,
            onClick: handleAutenticar,
            podeReenviar: false, // cliente de Portaria não existe em gw_mobile_clientes
          }}
          page="SMS"
          customPosition="modal-position-bottom"
          title="Validação"
          visibility={showModalSms}
          isFooter={false}
          btnOnClickClose={() => setShowModalSms(false)}
        />
      )}
      <ToastContainer containerId={''} position="top-center" autoClose={2500} style={{ fontSize: '18px' }} />
    </div>
  );
};
